/* eslint-disable radix */
// routes
import { paths } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_APP_API_URL || '';

export const GOOGLE_MAP_API = import.meta.env.VITE_APP_GOOGLE_MAP_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard/app'

// LOGO
// ----------------------------------------------------------------------

export const LOGO = {
  LIGHT: import.meta.env.VITE_APP_LIGHT_LOGO,
  DARK: import.meta.env.VITE_APP_DARK_LOGO,
};

// LANG
export const DEFAULT_LANG = import.meta.env.VITE_APP_DEFAULT_LANG || 'en';

// IMAGE
// ----------------------------------------------------------------------

export const CAMPAIGN_IMAGE_PATH = import.meta.env.VITE_APP_CAMPAIGN_ASSETS;
export const USER_ASSETS_PATH = import.meta.env.VITE_APP_USER_ASSETS || '';
export const CHAT_ASSETS_PATH = import.meta.env.VITE_APP_CHAT_ASSETS;
export const USER_IG_STORY_ASSETS_PATH = import.meta.env.VITE_APP_USER_IG_STORY_ASSETS || '';

//
// ----------------------------------------------------------------------
export const DEBOUNCE_DELAY = parseInt(`${import.meta.env.DEBOUNCE_DELAY}`) || 1000;
